import { render } from "./TilesGrid.vue?vue&type=template&id=2dd13b48"
import script from "./TilesGrid.vue?vue&type=script&lang=js"
export * from "./TilesGrid.vue?vue&type=script&lang=js"

import "./TilesGrid.vue?vue&type=style&index=0&id=2dd13b48&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__